import { render, staticRenderFns } from "./file-list.vue?vue&type=template&id=6b044476"
import script from "./file-list.vue?vue&type=script&lang=js"
export * from "./file-list.vue?vue&type=script&lang=js"
import style0 from "./file-list.vue?vue&type=style&index=0&id=6b044476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports